import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-applications',
  templateUrl: './user-applications.component.html',
  styleUrls: ['./user-applications.component.scss']
})
export class UserApplicationsComponent implements OnInit {
  @Input() userId;
  
  constructor() { }

  ngOnInit() {
  }

}
